import React from 'react';
import { Menu, Bell, Zap } from 'lucide-react';
import { useUIStore } from '@/store/uiStore';
import { useNotificationStore } from '@/store/notificationStore';
import { useAuthStore } from '@/store/authStore';
import { getInitials } from '@/lib/utils';
import styles from './layout.module.css';

export const TopBar: React.FC = () => {
  const { setMobileMenuOpen } = useUIStore();
  const toggleNotificationPanel = useNotificationStore((s) => s.toggleNotificationPanel);
  const { unreadCount } = useNotificationStore();
  const { profile } = useAuthStore();

  return (
    <header className={styles.topBar}>
      <button onClick={() => setMobileMenuOpen(true)} className={styles.topBarBtn} aria-label="Open navigation menu">
        <Menu size={20} />
      </button>

      <div className={styles.topBarLogo}>
        <div className={styles.topBarLogoIcon}><Zap size={14} /></div>
        <span className={styles.topBarLogoText}>CROS</span>
      </div>

      <div className={styles.topBarRight}>
        <button onClick={toggleNotificationPanel} className={styles.topBarBtn} style={{ position: 'relative' }} aria-label={`Notifications${unreadCount > 0 ? `, ${unreadCount} unread` : ''}`}>
          <Bell size={18} />
          {unreadCount > 0 && <span className={styles.topBarNotifBadge}>{unreadCount > 99 ? '99+' : unreadCount}</span>}
        </button>
        <div className={styles.topBarAvatar} aria-label={profile?.full_name ?? 'User avatar'}>
          {profile?.full_name ? getInitials(profile.full_name) : 'U'}
        </div>
      </div>
    </header>
  );
};
